import styled from '@emotion/styled'

export const ScrollingList = styled('div')`
    overflow: auto;
`
